module.exports = __webpack_public_path__ + "img/_temp_dashboard.a7b45789.svg";